<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Psychometric Interviews</span>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="psychometricResults"
        class="elevation-1"
        :loading="loading"
        loading-text="Loading... Please wait"
        no-data-text="No psychometric results available"
        hide-default-footer
        :disable-sort="true"
      >
        <template v-slot:item.id="{ item }">
          <span class="font-weight-medium">{{ item.id }}</span>
        </template>
        <template v-slot:item.role="{ item }">
          <b-link
            class="text-capitalize"
            @click="showReportDetails(item)"
            v-if="item?.result"
          >
            {{
              item.video_interview && item.video_interview.title
                ? item.video_interview.title
                : "N/A"
            }}
          </b-link>
          <span v-else class="text-black">
            {{
              item.video_interview && item.video_interview.title
                ? item.video_interview.title
                : "N/A"
            }}
          </span>
        </template>

        <template v-slot:item.overall_score="{ item }">
          <v-chip
            :color="
              getScoreColor(item.result ? item.result.overall_score : null)
            "
            dark
            small
          >
            {{ item.result ? `${item.result.overall_score}%` : "N/A" }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "TalentPsychometric",
  data() {
    return {
      loading: false,
      error: null,
      psychometricResults: [],
      headers: [
        {
          text: "Interview ID",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "Role",
          value: "role",
          sortable: true,
          align: "start",
        },
        {
          text: "Overall Score",
          value: "overall_score",
          sortable: true,
          align: "center",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profileData: "talentProfile/getProfileData",
    }),
  },
  methods: {
    ...mapActions({
      getProfileData: "talentProfile/getProfileData",
      getPsychometricResults: "talentProfile/getPsychometricResults",
    }),
    getScoreColor(score) {
      if (score === null || score === undefined) {
        return "grey";
      }

      if (score >= 80) {
        return "green";
      } else if (score >= 60) {
        return "orange";
      } else if (score >= 40) {
        return "deep-orange";
      } else {
        return "red";
      }
    },
    showReportDetails(interview) {
      const url =
        process.env.VUE_APP_TALENT_PROFILE_URL?.split("/sq/")[0] +
        `/sq/client/video-interviews/${this.profileData.basicInfo.sharable_code}?fromDashboard=true&interviewId=${interview.id}`;

      window.open(url, "_blank");
    },
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.getPsychometricResults(this.$route.params.id),
      this.getProfileData(this.$route.params.id),
    ])
      // eslint-disable-next-line no-unused-vars
      .then(([psychometricData, _]) => {
        this.psychometricResults = psychometricData;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.error = error;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}

.v-data-table {
  background-color: transparent;
}

.headline {
  color: #1976d2;
  font-weight: 500;
}
</style>
